(() => {
  const readyAttr = 'nyfLoopReady';

  const setup = (component) => {
    if (!component || component.dataset[readyAttr] === 'true') return;

    const slider = component.querySelector('[id^="Slider-"].product-grid');
    const prev = component.querySelector('button[name="previous"]');
    const next = component.querySelector('button[name="next"]');

    if (!slider || !prev || !next) return;

    component.dataset[readyAttr] = 'true';

    const keepEnabled = () => {
      prev.removeAttribute('disabled');
      next.removeAttribute('disabled');
      prev.setAttribute('aria-disabled', 'false');
      next.setAttribute('aria-disabled', 'false');
    };

    const getOffset = () => {
      const items = Array.from(slider.querySelectorAll('[id^="Slide-"]'))
        .filter((item) => item.clientWidth > 0);

      if (items.length > 1) {
        return items[1].offsetLeft - items[0].offsetLeft;
      }

      return items[0]?.clientWidth || slider.clientWidth;
    };

    const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';

    const handleClick = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const button = event.currentTarget;
      const step = Number(button.dataset.step || 1);
      const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const offset = getOffset() * step;
      const epsilon = 3;
      let target;

      if (button.name === 'next') {
        target = slider.scrollLeft >= maxScroll - epsilon
          ? 0
          : Math.min(maxScroll, slider.scrollLeft + offset);
      } else {
        target = slider.scrollLeft <= epsilon
          ? maxScroll
          : Math.max(0, slider.scrollLeft - offset);
      }

      slider.scrollTo({ left: target, behavior: scrollBehavior });
      window.setTimeout(keepEnabled, 350);
    };

    prev.addEventListener('click', handleClick, true);
    next.addEventListener('click', handleClick, true);

    const observer = new MutationObserver(keepEnabled);
    observer.observe(prev, { attributes: true, attributeFilter: ['disabled'] });
    observer.observe(next, { attributes: true, attributeFilter: ['disabled'] });

    slider.addEventListener('scroll', () => requestAnimationFrame(keepEnabled), { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(keepEnabled), { passive: true });

    keepEnabled();
  };

  const init = (root = document) => {
    root.querySelectorAll('slider-component').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();